/** Métricas de combo phantom (costo referencia + sellable) por sucursal. */

export type CatalogComboMetricsEntry = {
  isCombo: true;
  referenceUnitCost: number;
  referenceComplete: boolean;
  missingComponentProductId: string | null;
  sellableQty: number;
};

export type CatalogComboMetricsMap = Record<string, CatalogComboMetricsEntry>;

export function parseCatalogComboMetrics(raw: unknown): CatalogComboMetricsMap {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
  const out: CatalogComboMetricsMap = {};
  for (const [productId, value] of Object.entries(raw as Record<string, unknown>)) {
    if (!productId || !value || typeof value !== 'object' || Array.isArray(value)) continue;
    const v = value as Record<string, unknown>;
    if (v.isCombo !== true) continue;
    out[productId] = {
      isCombo: true,
      referenceUnitCost: Number(v.referenceUnitCost) || 0,
      referenceComplete: v.referenceComplete === true,
      missingComponentProductId:
        v.missingComponentProductId != null ? String(v.missingComponentProductId) : null,
      sellableQty: Number(v.sellableQty) || 0,
    };
  }
  return out;
}

/** Costo unitario efectivo para margen/completitud en catálogo. */
export function effectiveCatalogUnitCost(
  product: { isCombo?: boolean; stockAvgCost?: number | null; comboReferenceUnitCost?: number | null },
): number | null {
  if (product.isCombo) {
    const ref = product.comboReferenceUnitCost;
    return ref != null && ref > 0 ? ref : null;
  }
  const avg = product.stockAvgCost;
  return avg != null && avg > 0 ? avg : null;
}
